import { JSX, useEffect} from "react";
import { Routes as RouterRoutes, Route, useLocation } from "react-router-dom";

import Home from "../pages/Home";
import Sobre from "../pages/Sobre";
import Servicos from "../pages/Servicos";
import Projetos from "../pages/Projetos";
import Contact from "../pages/Contato";
import TrabalheConosco from "../pages/TrabalheConosco";
import Ombudsman from "../pages/Ouvidoria";
import ArticlesPage from "../pages/Artigos/ArticlesPage";

// import TransparenciaPage from "../components/TransparenciaPage";

import { History } from "../pages/Historia";

// pages projects
import Dipm from "../pages/Projetos/dipm";
import BarcarenaLogistica from "../pages/Projetos/barcarena-logistica";
import BarcarenaDrs from "../pages/Projetos/barcarena-drs";
import BarcarenaHse from "../pages/Projetos/barcarena-hse";
import SossegoVale from "../pages/Projetos/sossego";
import S11D from "../pages/Projetos/s11d";
import Paragominas from "../pages/Projetos/paragominas";
import PeraFerroviaria from "../pages/Projetos/pera-ferroviaria";
import Salobo from "../pages/Projetos/salobo";
import PlantaBenficiamento from "../pages/Projetos/planta-beneficiamento";
import CentroCultutal from "../pages/Projetos/centro-cultural";
import OzMinerals from "../pages/Projetos/oz-minerals";
import OreSorting from "../pages/Projetos/ore-sorting";


// Painel Administrativo
import SignIn from "../painel/signIn/signIn";
import SignInAdmin from "../painel/signIn/singIn-admin";
import Dashboard from "../painel/dashboard/dashboard"; // Placeholder for Dashboard component
import Treinamentos from "../painel/treinamentos/treinamentos";
import Layout from "../components/Layout";
import TreinamentoDetalhe from "../painel/treinamentos/TreinamentoDetalhe";

export default function AppRoutes() {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location])

    const PainelLayout = ({ children }: { children: React.ReactNode }) => {
        return <Layout>{children}</Layout>;
    }

    return(
        <RouterRoutes>
            <Route path="/" element={<Home />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/servicos" element={<Servicos />} />
            <Route path="/projetos" element={<Projetos />} />
            <Route path="/contato" element={<Contact />} />
            <Route path="/trabalheconosco" element={<TrabalheConosco />} />
            <Route path="/ouvidoria" element={<Ombudsman />} />
            <Route path="/conheca-a-seculos" element={<History />} />
            {/* <Route path="/transparencia" element={<TransparenciaPage />} /> */}
            <Route path="/artigos" element={<ArticlesPage />} />

            <Route path="/projetos/dipm" element={<Dipm />} />
            <Route path="/projetos/barcarena-logistica" element={<BarcarenaLogistica />} />
            <Route path="/projetos/barcarena-drs" element={<BarcarenaDrs />} />
            <Route path="/projetos/barcarena-hse" element={<BarcarenaHse />} />
            <Route path="/projetos/sossego-vale" element={<SossegoVale />} />
            <Route path="/projetos/s11d" element={<S11D />} />
            <Route path="/projetos/paragominas" element={<Paragominas />} />
            <Route path="/projetos/pera-ferroviaria" element={<PeraFerroviaria />} />
            <Route path="/projetos/salobo" element={<Salobo />} />
            <Route path="/projetos/planta-beneficiamento" element={<PlantaBenficiamento />} />
            <Route path="/projetos/centro-cultural" element={<CentroCultutal />} />
            <Route path="/projetos/oz-minerals" element={<OzMinerals />} />
            <Route path="/projetos/ore-sorting" element={<OreSorting />} />

            {/* Painel Administrativo */}
            <Route path="/painel/sign-in" element={<PainelLayout><SignIn/></PainelLayout>} />
            <Route path="/painel/sign-admin" element={<PainelLayout><SignInAdmin /></PainelLayout>} />
            <Route path="/painel/dashboard" element={<PainelLayout><Dashboard/></PainelLayout>} /> {/* Placeholder for Dashboard */}
            <Route path="painel/treinamentos" element={<PainelLayout><Treinamentos/></PainelLayout>} />
            <Route path="painel/treinamentos/:id" element={<PainelLayout><TreinamentoDetalhe/></PainelLayout>} />
        </RouterRoutes>
    )
}